export const refs = {
  tailsFilters: document.querySelector('.tails-filters'),
  tailsProducts: document.querySelector('.tails-products'),
  tailsBtn: document.querySelector('.tails-btn'),
  mwContainer: document.getElementById('mw'),
  loader: document.querySelector('.loader'),
};
